import {useState} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import LoadListListItemProjectSummary from "./LoadListListItemProjectSummary";

export default function LoadListListItemProject(props){
    //console.debug("RTS Break LoadListListItemProject");

    const[showProjectDialog, setShowProjectDialog] = useState(false);

    function openProject(){
        if(props.data.projectIdGuid==null){

        }
        else{
            setShowProjectDialog(true);
        }
    }

    
    if(props.data.projectIdGuid != null && props.data.projectIdGuid != '00000000-0000-0000-0000-000000000000'){
        return (
            <>
            <Dialog sx={{"& .MuiDialog-container": {"& .MuiPaper-root": {width: "100%", maxWidth: "400px",},},}} open={showProjectDialog} onClose={()=>{setShowProjectDialog(false);}}>
                <DialogTitle>Project Details</DialogTitle>
                <DialogContent>
                        <LoadListListItemProjectSummary idGuid={props.data.projectIdGuid} />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={e => {setShowProjectDialog(false);}}>Close</Button>
                </DialogActions>
            </Dialog>             

            <Link onClick={() => {openProject();}} sx={{textDecoration:'none', cursor:'pointer'}}>
                <Box sx={{display:'flex'}}>
                    <Typography variant="body2" sx={{fontWeight:'bold'}}>Project:</Typography>
                    <Typography variant="body2" sx={{ml:'2px'}}>{props.data.projectName==null?"No Project":props.data.projectName}</Typography>
                </Box>
            </Link>
            </>
        )
    }
    else{
        return (
            <Box sx={{display:'flex'}}>
                <Typography variant="body2" sx={{fontWeight:'bold'}}>Project:</Typography>
                <Typography variant="body2" sx={{ml:'2px'}}>{"No Project"}</Typography>
            </Box>
        )

    }
}

